import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';
import {Router} from '@angular/router';
import {AppConstant} from '../../shared/utility/app-constant';
import {PrivilegeService} from '../../shared/services/privilege.service';
import {AppAuthorities} from '../../shared/enums/app-authorities';

@Directive({
  selector: '[appShortcutKeys]'
})
export class ShortcutKeysDirective {
  public appAuthorities = AppAuthorities;
  @Output() shortcutKeyPressed = new EventEmitter();

  constructor(private router: Router, public privilegeService: PrivilegeService) {}

  /**
   * This method is used to keyboard navigation
   */
  @HostListener('window:keydown', ['$event'])
  navigation(event: KeyboardEvent) {
    const targetTagName = (event.target as HTMLElement).tagName;
    if (!(targetTagName === 'INPUT' || targetTagName === 'TEXTAREA')) {
      event.stopPropagation();
      const key = event.key.toUpperCase();
      if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_D) {
        this.router.navigateByUrl(AppConstant.DASHBOARD_URL);
        return;
      } else if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_I &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.INBOX_URL)) {
        this.router.navigateByUrl(AppConstant.INBOX_URL);
        return;
      } else if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_P &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.PURCHASE_ORDERS_URL)) {
        this.router.navigateByUrl(AppConstant.PURCHASE_ORDERS_URL);
        return;
      } else if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_B &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.BILLS_URL)) {
        this.router.navigateByUrl(AppConstant.BILLS_URL);
        return;
      } else if (!event.altKey && event.shiftKey && key === AppConstant.LETTER_P &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.PAYMENTS_URL)) {
        this.router.navigateByUrl(AppConstant.PAYMENTS_URL);
        return;
      } else if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_A &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.ACCOUNT_URL)) {
        this.router.navigateByUrl(AppConstant.ACCOUNT_URL);
        return;
      } else if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_E &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.EXPENSES_URL)) {
        this.router.navigateByUrl(AppConstant.EXPENSES_URL);
        return;
      } else if (event.shiftKey && !event.altKey && key === AppConstant.LETTER_I &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.ITEMS_URL)) {
        this.router.navigateByUrl(AppConstant.ITEMS_URL);
        return;
      } else if (event.shiftKey && event.altKey && key === AppConstant.LETTER_P &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.PROJECTS_URL)) {
        this.router.navigateByUrl(AppConstant.PROJECTS_URL);
        return;
      } else if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_V &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.VENDORS_URL)) {
        this.router.navigateByUrl(AppConstant.VENDORS_URL);
        return;
      } else if (event.shiftKey && event.altKey && key === AppConstant.LETTER_I &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.INVOICES_URL)) {
        event.preventDefault();
        this.router.navigateByUrl(AppConstant.INVOICES_URL);
        return;
      } else if (event.shiftKey && key === AppConstant.LETTER_A &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.AUTOMATION_URL)) {
        this.router.navigateByUrl(AppConstant.AUTOMATION_URL);
        return;
      } else if (event.ctrlKey && event.altKey && !event.shiftKey && key === AppConstant.LETTER_R &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.REPORTS_URL)) {
        this.router.navigateByUrl(AppConstant.REPORTS_URL);
        return;
      } else if (event.shiftKey && key === AppConstant.LETTER_S && !event.altKey &&
        this.checkUserHasPrivilegesForHomeScreen(AppConstant.SETTINGS_URL)) {
        this.router.navigateByUrl(AppConstant.SETTINGS_URL);
        return;
      }
    }

    this.executeComponentMethod(event);
  }

  /**
   * This method is used check user can navigate specific module
   */
  checkUserHasPrivilegesForHomeScreen(navigateUrl: string) {
    const slimMenu = JSON.parse(localStorage.getItem(AppConstant.NAV_ITEMS));
    for (const item of slimMenu?.slimMenu) {
      if (item.routerLink && Array.isArray(item.routerLink)) {
        if (item.routerLink.includes(navigateUrl)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * This method is used to execute specific method in components related to shortcut keys
   */
  executeComponentMethod(event: KeyboardEvent) {
      event.stopPropagation();
      const key = event.key?.toUpperCase();
      if (!event.shiftKey && event.ctrlKey && event.key === AppConstant.ENTER) {
        this.shortcutKeyPressed.emit(AppConstant.SUBMIT);
        return;
      } else if (!event.ctrlKey && event.altKey && event.shiftKey && key === AppConstant.LETTER_R) {
        this.shortcutKeyPressed.emit(AppConstant.RESET);
        return;
      } else if (!event.ctrlKey && !event.shiftKey && event.altKey && key === AppConstant.LETTER_N) {
        this.shortcutKeyPressed.emit(AppConstant.CREATE);
        return;
      } else if (!event.ctrlKey && !event.shiftKey && !event.altKey && event.key === AppConstant.ESCAPE) {
        this.shortcutKeyPressed.emit(AppConstant.CLOSE);
        return;
      } else if (!event.shiftKey && event.ctrlKey && key === AppConstant.LETTER_E) {
        event.preventDefault();
        this.shortcutKeyPressed.emit(AppConstant.EDIT);
        return;
      } else if (!event.shiftKey && !event.ctrlKey && event.altKey && key === AppConstant.LETTER_D) {
        event.preventDefault();
        this.shortcutKeyPressed.emit(AppConstant.DELETE);
        return;
      } else if (!event.ctrlKey && event.altKey && event.shiftKey && event.code === AppConstant.BRACKET_LEFT) {
        this.shortcutKeyPressed.emit(AppConstant.PREVIOUS);
        return;
      } else if (!event.ctrlKey && event.altKey && event.shiftKey && event.code === AppConstant.BRACKET_RIGHT) {
        this.shortcutKeyPressed.emit(AppConstant.NEXT);
        return;
      } else if (!event.shiftKey && !event.ctrlKey && event.altKey && key === AppConstant.LETTER_U) {
        this.shortcutKeyPressed.emit(AppConstant.UPLOAD);
        return;
      }
  }

  @HostListener('window:keyup.alt.U', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    event.stopPropagation();
    this.shortcutKeyPressed.emit(AppConstant.UPLOAD);
  }
}
